import api from '../../api';
import { API } from '../../api/apiConstants';
import { FontLocation } from '../../themes/themeConstants';

export const fontTypeMap: { [key: string]: string } = {
  ttf: 'trueType',
  otf: 'openType',
  woff: 'woff',
  woff2: 'woff2',
};

const knownFontNames: Set<string> = new Set([
  'Arial',
  'Calibri',
  'Times New Roman',
  'Verdana',
  'Georgia',
  'Helvetica',
  'Courier New',
]);
//prevents requesting already existing fonts
const loadedFonts = new Set<string>();

const loadCustomFont = async (rawTheme: any) => {
  const fontFamilies: Set<string> = new Set<string>();

  if (rawTheme.typography) {
    if (
      rawTheme.typography.fontFamily &&
      !knownFontNames.has(rawTheme.typography.fontFamily)
    ) {
      fontFamilies.add(rawTheme.typography.fontFamily);
    }
    for (const key in rawTheme.typography) {
      if (rawTheme.typography[key]?.fontFamily) {
        if (!knownFontNames.has(rawTheme.typography[key].fontFamily)) {
          fontFamilies.add(rawTheme.typography[key].fontFamily);
        }
      }
    }
  }
  if (fontFamilies.size !== 0) {
    api.Public.getRequiredFonts(fontFamilies).then(
      (fontsToSet: FontLocation[]) => {
        if (fontsToSet.length > 0) {
          setCustomFontFaces(fontsToSet);
        }
      }
    );
  } else {
    return;
  }
};

export const loadCustomFontForRichText = async (requiredFonts: Set<string>) => {
  const filteredRequiredFonts = new Set(
    Array.from(requiredFonts).filter(
      (font) =>
        !knownFontNames.has(font) && !Array.from(loadedFonts).includes(font)
    )
  );
  filteredRequiredFonts.forEach((font) => loadedFonts.add(font));

  if (filteredRequiredFonts.size > 0) {
    api.Public.getRequiredFonts(filteredRequiredFonts).then(
      (fontsToSet: FontLocation[]) => {
        if (fontsToSet.length > 0) {
          setCustomFontFaces(fontsToSet);
        }
      }
    );
  }
};

const setCustomFontFaces = (fontResources: FontLocation[]) => {
  fontResources.forEach((font) => {
    const fontName = font.fontName;
    const fontFormat = font.fileExtension
      ? fontTypeMap[font.fileExtension]
      : '';

    const style = document.createElement('style');
    if (font.fileExtension) {
      style.innerHTML =
        `@font-face {font-family: '${fontName}';\n src: url('${API.V3.FONT_RESOURCES.FONT_RESOURCE(
          font.fontLocation
        )}') format('${fontFormat}');\n}
                `.trim();
      document.head.appendChild(style);
    }
  });
};

export default loadCustomFont;
